import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, List, Table, TableBody, TableCell, TableHead, TableRow, Alert } from '@mui/material';
import { ExpandMore, Architecture } from '@mui/icons-material';
import { SectionHeader, Done, Todo, CodeBlock } from './DocPrimitives';
import { STACK_ARCHITECTURE, DESIGN_DECISIONS_DONE, DESIGN_DECISIONS_TODO, CDK_COMMANDS, ENV_VARS } from '../../data/docs/infrastructure';

export default function InfrastructureTab() {
  return (
    <Box>
      <SectionHeader icon={<Architecture />} title="Infrastructure as Code" subtitle="AWS CDK (TypeScript) — all infrastructure is version-controlled and reproducible" />

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Stack Architecture</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body2" color="text.secondary" mb={2}>
            The platform is deployed as independent CDK stacks. Each stack owns a domain and can be deployed or torn down without affecting others.
          </Typography>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><strong>Stack</strong></TableCell>
                <TableCell><strong>Owns</strong></TableCell>
                <TableCell><strong>Depends on</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {STACK_ARCHITECTURE.map(({ stack, owns, deps }) => (
                <TableRow key={stack}>
                  <TableCell><code>{stack}</code></TableCell>
                  <TableCell><Typography variant="caption">{owns}</Typography></TableCell>
                  <TableCell><Typography variant="caption" color="text.secondary">{deps}</Typography></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Key Design Decisions</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List dense disablePadding>
            {DESIGN_DECISIONS_DONE.map((item, i) => <Done key={i}>{item}</Done>)}
            {DESIGN_DECISIONS_TODO.map((item, i) => <Todo key={i}>{item}</Todo>)}
          </List>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Common CDK Commands</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <CodeBlock>{CDK_COMMANDS}</CodeBlock>
          <Alert severity="info" sx={{ mt: 1 }}>
            <Typography variant="body2">Deployment is handled by the CI/CD pipeline, not by running <code>cdk deploy</code> locally. See the CI/CD tab.</Typography>
          </Alert>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Typography fontWeight={600}>Environment Variables</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'grey.50' }}>
                <TableCell><strong>Variable</strong></TableCell>
                <TableCell><strong>Purpose</strong></TableCell>
                <TableCell><strong>Example</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ENV_VARS.map(({ variable, purpose, example }) => (
                <TableRow key={variable}>
                  <TableCell><code>{variable}</code></TableCell>
                  <TableCell><Typography variant="caption">{purpose}</Typography></TableCell>
                  <TableCell><Typography variant="caption" color="text.secondary">{example}</Typography></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
